/* eslint-disable */
import React, { useEffect, useContext, useState } from "react";
import { Link, useParams } from "react-router-dom";

//import translation function for language translation
import { useTranslation } from "react-i18next";

import { assetImages } from "constants";

/*import url and gateway methods */
import { postData, putData, uploadMultipleFile, getData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import downloadFileHandler from "helper/DownloadFile";
import {
  getDateFormatInSpanish,
  getFileIcon,
} from "helper/Common/CommonHelper";

import TaskStatusOptions from "data/Prod/TaskStatus.json";
import TaskPriority from "data/Prod/TaskPriority.json";
import {
  convertSecondsToHour,
  differenceToSeconds,
  displayFormatedTime,
  getCurrentTime,
  getTimeDifference,
} from "helper/TimeCalculation";
import StopTaskWarningModal from "components/Common/Modal/StopTaskWarningModal";
import SaveLogTimerModal from "components/Common/Modal/SaveLogTimerModal";
import ExistingTaskWarningModal from "components/Common/Modal/ExistingTaskWarningModal";

const ViewTaskTab = ({
  setTaskHistory = () => {},
  // taskDetailsObj = {},
  setShowTaskEditForm = () => {},
  setShowAlert,
  setAlertMessage,
  setMessageType,
  setnoteAccessUserList,
}) => {
  const todayValue = new Date().toISOString().split("T")[0];

  const params = useParams();

  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  /* ------------- Language translation imports starts here ------------- */
  const { t } = useTranslation();

  const [isModerator, setIsModerator] = useState(false);
  const [moderatorName, setmoderatorName] = useState("");
  const [moderatorImage, setmoderatorImage] = useState("");
  const [assignedUserId, setAssignedUserId] = useState(null);
  const [userName, setUserName] = useState("");
  const [userImage, setUserImage] = useState("");
  const [taskFollowers, setTaskFollowers] = useState([]);
  const [projectName, setprojectName] = useState("");
  const [projectId, setprojectId] = useState(null);
  const [leadId, setleadId] = useState(null);
  const [contactId, setcontactId] = useState(null);
  const [customId, setCustomId] = useState(null);
  const [title, settitle] = useState("");
  const [details, setdetails] = useState("");
  const [startDate, setstartDate] = useState(todayValue);
  const [endDate, setendDate] = useState(todayValue);
  const [taskStartTime, setTaskStartTime] = useState("");
  const [hours, sethours] = useState("");
  const [price, setPrice] = useState("");
  const [priority, setpriority] = useState("");
  const [taskStatus, settaskStatus] = useState("");
  const [uploadedDocFiles, setUploadedDocFiles] = useState([]);
  const [taskpercent, settaskpercent] = useState(0);
  const [completedpercent, setcompletedpercent] = useState("");
  const [childTasks, setchildTasks] = useState([]);
  const [taskCreatedDate, settaskCreatedDate] = useState("");

  const [showTaskHourInput, setShowTaskHourInput] = useState(false);
  const [showTaskDateInput, setShowTaskDateInput] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  // timmer ----------------------------------------------------------------
  const [timer, setTimer] = useState(0);
  const [isWorking, setIsWorking] = useState(false);
  const [logId, setLogId] = useState(null);
  const [workHours, setWorkHours] = useState(0);

  const [runningTaskId, setrunningTaskId] = useState(null);

  //function for get project details
  const getTaskDetails = async (isTimer = false) => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_TASK_DETAILS +
        `/${params.id}?token=${token}`;

      const response = await getData(requestUrl);

      console.log("response in view task details", response);

      if (response.status && response.data) {
        if (
          userInfo.role.slug === "ADMIN" ||
          userInfo.role.slug === "SUPER_ADMIN" ||
          userInfo._id.toString() === response.data.moderator.toString()
        ) {
          setIsModerator(true);
        } else {
          setIsModerator(false);
        }

        setCustomId(response.data.customid);
        settitle(response.data.title);
        setdetails(response.data.description);
        setmoderatorName(response.data.moderatorname);
        setmoderatorImage(response.data.moderatorimage);
        setUserName(response.data.assignedusername);
        setUserImage(response.data.assigneduserimage);
        setTaskFollowers(response.data.followersarr);
        setprojectName(response.data.projectname);
        setprojectId(response.data.project?._id);
        setleadId(response.data.lead?._id);
        setcontactId(response.data.contact?._id);
        sethours(response.data.hours);
        setPrice(response.data.price ?? 0);
        setstartDate(response.data?.startdate ?? "");
        setendDate(response.data?.enddate ?? "");
        setpriority(response.data.taskpriority);
        settaskStatus(response.data.taskstatus);
        //assign uploaded files
        setUploadedDocFiles(response?.data?.uploadedfiles);

        settaskpercent(response?.data?.taskpercent);
        setcompletedpercent(response?.data?.completedpercent);

        setchildTasks(response?.data?.childtasks);
        settaskCreatedDate(response?.data?.taskcreateddate ?? "");

        if (response.data.customid) {
          let histroyRequestUrl =
            url.API_BASE_URL +
            url.API_GET_TASK_HISTORY +
            `?token=${token}&taskid=${params.id}`;

          console.log("histroyRequestUrl", histroyRequestUrl);

          const historyResponse = await getData(histroyRequestUrl);

          console.log("historyResponse", historyResponse);

          if (historyResponse.status && historyResponse.data) {
            setTaskHistory(historyResponse.data);
          }
        }

        if (response.data.assigneduser) {
          setAssignedUserId(response.data.assigneduser._id);
        }

        // Always start with moderator and assigned user
        const baseUsers = [response.data.moderator];

        if (response.data.assigneduser) {
          baseUsers.push(response.data.assigneduser._id);
        }

        // Add followers if they exist
        const followerIds =
          response.data.followers?.length > 0
            ? response.data.followers.map((item) => item._id)
            : [];

        // Combine and filter
        const combinedUsers = [...baseUsers, ...followerIds];
        const filterNoteFollowers = combinedUsers.filter(
          (item) => item.toString() !== userInfo._id.toString()
        );

        setnoteAccessUserList(filterNoteFollowers);

        if (response?.data?.isworking) {
          setIsWorking(true);

          if (response?.data?.starttime !== "") {
            setTaskStartTime(response?.data?.starttime ?? "");
            const timeDiffenceResult = getTimeDifference(
              response?.data?.starttime
            );

            const timeDifferenceIntoSec =
              differenceToSeconds(timeDiffenceResult);
            setTimer(timeDifferenceIntoSec);
          }
        } else {
          setIsWorking(false);
          setTimer(0);
        }

        if (!isTimer) setMessageType("success");
      } else {
        if (!isTimer) setMessageType("error");
      }
      if (!isTimer) {
        setAlertMessage(response.message);
        setShowAlert(true);
      }
    } catch (error) {
      console.log("error in get task details", error.message);
      setMessageType("error");
      setAlertMessage(error.message);
      setShowAlert(true);
    }
  };

  //save task
  const saveTaskHandler = async () => {
    try {
      setIsSaving(true);

      let taskData = {
        hours,
        startdate: startDate,
        enddate: endDate,
      };

      // console.log(taskData);

      let response = {};

      let requestUrl =
        url.API_BASE_URL +
        url.API_UPDATE_PROJECT_TASK +
        `/${params.id}?token=${token}`;

      response = await putData(requestUrl, taskData);

      setIsSaving(false);

      // console.log(response);

      if (response.status) {
        setShowTaskHourInput(false);
        setShowTaskDateInput(false);
        setMessageType("success");
        setTimeout(() => {
          getTaskDetails();
        }, 1000);
      } else {
        setMessageType("error");
      }
      setAlertMessage(response.message);
    } catch (error) {
      setMessageType("error");
      setAlertMessage(error.message);
    }

    setShowAlert(true);
  };

  // when user login and start the day
  const logStartingHandler = async () => {
    try {
      let runningTaskUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_TASKS +
        `?token=${token}&filterisworking=${true}&filterusers=${userInfo._id}`;

      // console.log("runningTaskUrl", runningTaskUrl);

      const runningTaskResponse = await getData(runningTaskUrl);

      // console.log("runningTaskResponse", runningTaskResponse);

      if (runningTaskResponse.status) {
        if (runningTaskResponse.data.length > 0) {
          setrunningTaskId(runningTaskResponse.data[0]._id);

          const bootstrapModal = new bootstrap.Modal(
            document.getElementById("existingtaskwarning")
          );
          bootstrapModal.show();
        } else {
          setIsWorking(true);

          let taskData = {
            isworking: true,
            lastworkingdate: todayValue,
            starttime: getCurrentTime(),
            endtime: "",
            completedpercent: "2", // 2 means in-progress
            logdata: null,
          };

          let requestUrl =
            url.API_BASE_URL +
            url.API_UPDATE_TASK_TIMER +
            `/${params.id}?token=${token}`;

          const response = await putData(requestUrl, taskData);

          console.log("response in save log----->", response);

          if (response.status) {
            getTaskDetails(true);
          }
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  // when user about to logout and stop the day
  const logStopingHandler = async () => {
    setIsWorking(false);

    const currentTimeHours = convertSecondsToHour(timer);

    setWorkHours(currentTimeHours);

    const bootstrapModal = new bootstrap.Modal(
      document.getElementById("saveLogTimerModal")
    );
    bootstrapModal.show();

    setTimer(0);
  };

  // counter for timer on each second
  useEffect(() => {
    let intervalId;

    if (isWorking) {
      intervalId = setInterval(() => {
        setTimer((prevTimer) => prevTimer + 1);
      }, 1000);
    } else {
      clearInterval(intervalId);
    }

    return () => clearInterval(intervalId);
  }, [isWorking]);

  useEffect(() => {
    if (params.id) {
      getTaskDetails();
    }
  }, [params.id]);

  return (
    <div className="p-4">
      <form onSubmit={(e) => e.preventDefault()}>
        <div className="form-group mb-4">
          {/* <!-- ========== Start task id and title Section ========== --> */}
          <div className="user_task_hdng">
            <h2>
              {customId ? (
                <span className="badge bg-dark me-3">{customId}</span>
              ) : null}
              {title}
            </h2>{" "}
          </div>
          {/* <!-- ========== End task id and title Section ========== --> */}
          <div className="d-flex justify-content-between align-items-center">
            {" "}
            <div
              className={
                assignedUserId &&
                assignedUserId.toString() === userInfo._id.toString()
                  ? "action d-flex align-items-center gap-2 mb-4"
                  : "d-none"
              }
            >
              {isWorking ? (
                <Link
                  to="#"
                  className="btn btn-success d-flex align-items-center gap-1"
                  data-bs-toggle="modal"
                  data-bs-target="#stoptaskwarning"
                >
                  <span className="d-block material-symbols-outlined icon-md">
                    stop_circle
                  </span>
                  <span className="d-block">Stop Working</span>
                </Link>
              ) : (
                <Link
                  to="#"
                  className="btn btn-primary d-flex align-items-center gap-1"
                  onClick={() => {
                    // setIsWorking(true);
                    logStartingHandler();
                  }}
                >
                  <span className="d-block material-symbols-outlined icon-md">
                    play_circle
                  </span>
                  <span className="d-block">Start Working</span>
                </Link>
              )}

              <div className="search-container position-relative d-none d-md-block">
                <p>
                  {t("Timer")}: {displayFormatedTime(timer)}
                </p>
              </div>
            </div>
            <div
              className={
                isModerator
                  ? "action d-flex align-items-center gap-2 mb-4"
                  : "d-none"
              }
            >
              <button
                className="btn btn-outline-primary d-flex align-items-center gap-1"
                onClick={() => {
                  setShowTaskEditForm(true);
                }}
              >
                Edit Task
              </button>
            </div>
          </div>
          {/* <!-- ========== Start other information Section ========== --> */}
          <div className="task_info_innr">
            {/* start assigned by Section */}
            <div className="task_info_row d-flex align-items-center gap-1 mb-2 py-2">
              <label className="fw-semibold">Assigned By</label>
              <div className="sign_prsn_outer d-flex align-items-center gap-2 flex-wrap">
                {moderatorName === "" ? null : (
                  <div className="aign_usr_item bg-gray-300 rounded-8 px-2 py-1 d-flex align-items-center gap-1">
                    <span className="rounded-circle d-block usr_img">
                      <img
                        height={22}
                        className="rounded-circle"
                        src={
                          moderatorImage == ""
                            ? assetImages.defaultUser
                            : url.SERVER_URL + moderatorImage
                        }
                        alt=""
                      />
                    </span>
                    <span className="d-block">{moderatorName}</span>
                  </div>
                )}
              </div>
            </div>
            {/* end assigned by Section */}
            {/* <!-- ========== Start task assigned user Section ========== --> */}
            <div className="task_info_row d-flex align-items-center gap-1 mb-2 py-2">
              <label className="fw-semibold">Assigned to</label>
              <div className="sign_prsn_outer d-flex align-items-center gap-2 flex-wrap">
                {userName === "" ? null : (
                  <div className="aign_usr_item bg-gray-300 rounded-8 px-2 py-1 d-flex align-items-center gap-1">
                    <span className="rounded-circle d-block usr_img">
                      <img
                        height={22}
                        className="rounded-circle"
                        src={
                          userImage == ""
                            ? assetImages.defaultUser
                            : url.SERVER_URL + userImage
                        }
                        alt=""
                      />
                    </span>
                    <span className="d-block">{userName}</span>
                  </div>
                )}
              </div>
            </div>
            {/* <!-- ========== End task assigned user Section ========== --> */}

            {/* <!-- ========== Start task followers Section ========== --> */}
            <div className="task_info_row d-flex align-items-center gap-1 mb-2 py-2">
              <label className="fw-semibold">Follower</label>
              {taskFollowers.length === 0 ? null : (
                <div className="sign_prsn_outer d-flex align-items-center gap-2 flex-wrap">
                  {taskFollowers.map((follower, index) => {
                    return (
                      <div
                        className="aign_usr_item bg-gray-300 rounded-8 px-2 py-1 d-flex align-items-center gap-1"
                        key={index}
                      >
                        <span className="rounded-circle d-block usr_img">
                          <img
                            height={22}
                            className="rounded-circle"
                            src={
                              follower.imagepath == ""
                                ? assetImages.defaultUser
                                : url.SERVER_URL + follower.imagepath
                            }
                            alt=""
                          />
                        </span>
                        <span className="d-block">{follower.label}</span>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
            {/* <!-- ========== End task followers Section ========== --> */}

            {/* project section start */}
            <div className="task_info_row d-flex align-items-center gap-1 mb-2 py-2">
              <label className="fw-semibold">Project</label>
              <h5 className="mb-0 text-black fs-md">{projectName}</h5>
            </div>
            {/* project section end */}

            {/* status section start */}
            <div className="task_info_row d-flex align-items-center gap-1 mb-2 py-2">
              <label className="fw-semibold">Status</label>
              <h5 className="d-flex align-items-center gap-1">
                <i className="material-symbols-outlined text-green fs-lg">
                  check_circle
                </i>
                <span className="text-black fs-md">{taskStatus}</span>
              </h5>
            </div>
            {/* status section end */}

            {/* time section start  */}
            <div className="task_info_row d-flex align-items-center gap-1 mb-2 py-2">
              <label className="fw-semibold">Time(Hrs)</label>
              {showTaskHourInput ? (
                <div className="d-flex gap-2">
                  <input
                    min={0}
                    type="number"
                    className="form-control fs-sm shadow-none border border-1 bg-white"
                    value={hours}
                    onChange={(e) => sethours(e.target.value)}
                  />
                  <button
                    className="btn btn-primary fs-sm d-flex align-items-center"
                    onClick={saveTaskHandler}
                    style={{ cursor: isSaving ? "not-allowed" : "pointer" }}
                    disabled={isSaving ? true : false}
                  >
                    Save
                    {isSaving && (
                      <div
                        className="mx-2 spinner-border spinner-border-sm"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    )}
                  </button>
                  <button
                    className="btn btn-secondary fs-sm"
                    onClick={() => setShowTaskHourInput(false)}
                  >
                    Cancel
                  </button>
                </div>
              ) : (
                <h5 className="d-flex align-items-center gap-1">
                  <i className="material-symbols-outlined text-orange fs-lg">
                    schedule
                  </i>
                  <span className="mb-0 text-black fs-md">{hours} Hrs</span>
                  <Link
                    to="#"
                    onClick={() => {
                      setShowTaskHourInput(!showTaskHourInput);
                    }}
                  >
                    <i className="material-symbols-outlined text-gray-600 fs-lg">
                      edit
                    </i>
                  </Link>
                </h5>
              )}
            </div>
            {/* time section end  */}

            {/* created date section start */}
            <div className="task_info_row d-flex align-items-center gap-1 mb-2 py-2">
              <label className="fw-semibold">Created Date</label>
              <h5 className="mb-0 text-black fs-md d-flex align-items-center gap-1">
                <i className="material-symbols-outlined fs-lg text-gray">
                  calendar_today
                </i>
                <span className="mb-0 text-black fs-md">{taskCreatedDate}</span>
              </h5>
            </div>
            {/* created date section end */}

            {/* deadline section start */}
            <div className="task_info_row d-flex align-items-center gap-1 mb-2 py-2">
              <label className="fw-semibold">Deadline</label>
              {showTaskDateInput ? (
                <div className="d-flex gap-2">
                  <input
                    type="date"
                    className="form-control fs-sm shadow-none border border-1 bg-white"
                    value={startDate}
                    onChange={(e) => setstartDate(e.target.value)}
                  />
                  <input
                    type="date"
                    className="form-control fs-sm shadow-none border border-1 bg-white"
                    value={endDate}
                    onChange={(e) => setendDate(e.target.value)}
                  />
                  <button
                    className="btn btn-primary fs-sm d-flex align-items-center"
                    onClick={saveTaskHandler}
                    style={{ cursor: isSaving ? "not-allowed" : "pointer" }}
                    disabled={isSaving ? true : false}
                  >
                    Save
                    {isSaving && (
                      <div
                        className="mx-2 spinner-border spinner-border-sm"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    )}
                  </button>
                  <button
                    className="btn btn-secondary fs-sm"
                    onClick={() => setShowTaskDateInput(false)}
                  >
                    Cancel
                  </button>
                </div>
              ) : (
                <h5 className="d-flex align-items-center gap-1">
                  <i className="material-symbols-outlined fs-lg text-gray">
                    calendar_today
                  </i>
                  <span className="mb-0 text-black fs-md">
                    {getDateFormatInSpanish(startDate)} To{" "}
                    {getDateFormatInSpanish(endDate)}
                  </span>
                  <Link
                    to="#"
                    onClick={() => {
                      setShowTaskDateInput(!showTaskDateInput);
                    }}
                  >
                    <i className="material-symbols-outlined text-gray-600 fs-lg">
                      edit
                    </i>
                  </Link>
                </h5>
              )}
            </div>
            {/* deadline section end */}

            {/* priority section start */}
            <div className="task_info_row d-flex align-items-center gap-1 mb-2 py-2">
              <label className="fw-semibold">Priority</label>
              <div className="piority_status d-inline-flex align-items-center py-1 px-2 rounded-10 bg-primary text-white fs-xs">
                {priority}
              </div>
            </div>
            <div className="task_info_row d-flex align-items-center gap-1 py-2">
              <label className="fw-semibold">Price (Euro)</label>
              <h5 className="d-flex align-items-center gap-1">
                <i className="material-symbols-outlined text-green fs-lg">
                  euro
                </i>
                <span className="mb-0 text-black fs-md">{price}</span>
              </h5>
            </div>
          </div>
          {/* <!-- ========== End other information Section ========== --> */}
        </div>

        {/* <!-- ========== Start task details Section ========== --> */}
        <div className="form-group mb-4">
          <label htmlFor="Details" className="d-block fs-sm fw-semibold mb-2">
            Details
          </label>
          <div className="details_para">
            <p dangerouslySetInnerHTML={{ __html: details }}></p>
          </div>
        </div>
        {/* <!-- ========== End task details Section ========== --> */}

        {/* <!-- ========== Child task details Section ========== --> */}
        <div className={childTasks.length > 0 ? "form-group mb-4" : "d-none"}>
          <label htmlFor="Details" className="d-block fs-sm fw-semibold mb-2">
            Child Tasks
          </label>
          <div className="details_para">
            {childTasks.map((task, index) => {
              return (
                <Link
                  to={`/admin/task/details/${task._id}`}
                  target="_blank"
                  className="fs-sm fw-semibold text-primary"
                  key={index}
                >
                  {task.customid}
                  {" - "}
                  {task.title}
                </Link>
              );
            })}
          </div>
        </div>
        {/* <!-- ========== End Child details Section ========== --> */}

        {/* <!-- ========== Start uploaded file Section ========== --> */}
        <div
          className={uploadedDocFiles.length > 0 ? "form-group mb-4" : "d-none"}
        >
          <label
            htmlFor="attachments"
            className="d-block fs-sm fw-semibold mb-2"
          >
            Attachments
          </label>
          <ul className="uploaded-files d-flex flex-wrap gap-3 p-0 m-0 mt-3">
            {uploadedDocFiles.map((file, index) => {
              const fileObj = {
                ...file,
                path: url.SERVER_URL + file.path,
              };

              return (
                <li
                  className="file d-flex file_gap align-items-center px-3 py-2 border border-gray rounded-3 shadow-sm"
                  key={index}
                >
                  <span className="material-symbols-outlined text-primary">
                    {getFileIcon(file.name)}
                  </span>
                  <p className="fw-medium text-truncate me-auto mb-0">
                    {file.name}
                  </p>
                  <Link
                    className="p-2 bg-light rounded-5 border border-gray-300"
                    to="#"
                    onClick={() => downloadFileHandler(fileObj)}
                  >
                    <span className="d-block material-symbols-outlined icon-md text-gray-600 fw-medium">
                      download
                    </span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
        {/* <!-- ========== End uploaded file Section ========== --> */}
      </form>

      <ExistingTaskWarningModal taskId={runningTaskId} />

      <StopTaskWarningModal onStop={logStopingHandler} />

      <SaveLogTimerModal
        logId={logId}
        workHours={workHours}
        taskStartTime={taskStartTime}
        projectId={projectId}
        leadId={leadId}
        contactId={contactId}
        taskpercent={taskpercent}
        completedpercent={completedpercent}
        getTaskDetails={getTaskDetails}
      />
    </div>
  );
};

export default ViewTaskTab;
